import { Check } from 'lucide-react';
import { firstName, fmtFullDay, fmtTime, zoneShort } from '../lib/format';
import { ButtonLink } from '../ui';
import { useIntake } from './IntakeContext';
import { IntakeLayout } from './IntakeLayout';
import { DONE_STEP } from './logic';
import { usePageHeading } from '../firm/usePageHeading';

export function Confirmation() {
  const { state, answers } = useIntake();
  const k = state.kickoff;
  const lead = firstName(state.lead.name, 'We');
  const email = answers.contact?.email;
  usePageHeading('You’re all set');
  const line = k?.status === 'contact_requested'
    ? `We have your answers. ${lead} will email you within one business day to find a time that works.`
    : k?.status === 'booked' && k.startsAt
      ? `Your Discovery Session is booked for ${fmtFullDay(k.startsAt)} at ${fmtTime(k.startsAt)} ${zoneShort(new Date(k.startsAt))}.${email ? ` A calendar invite is on its way to ${email}.` : ''}`
      : 'We have your answers. Your Discovery Session details will appear here once it is booked.';
  return (
    <IntakeLayout step={DONE_STEP} maxReached={DONE_STEP}>
      <div className="flex flex-col items-start gap-5">
        <div className="flex w-full flex-col items-start gap-4 rounded-card border border-line bg-white p-5 sm:p-7">
        <span aria-hidden="true" className="flex h-12 w-12 items-center justify-center rounded-full bg-brand text-white"><Check size={24} strokeWidth={2.6} /></span>
        <div className="flex flex-col gap-2">
          <h1 className="m-0 text-[26px] font-bold leading-[1.2] tracking-[-0.02em] sm:text-[30px]" tabIndex={-1} data-page-heading style={{ outline: "none" }}>You’re all set, {firstName(answers.contact?.name)}</h1>
          <p className="m-0 max-w-[680px] text-base leading-[1.55] text-ink-2">{line}</p>
        </div>
        </div>
        <div className="box-border w-full rounded-card border border-line bg-white px-5 py-[18px]">
          <div className="mb-2 text-base font-semibold">Before the call</div>
          <ul className="m-0 flex list-disc flex-col gap-1 pl-5 text-ink-2 marker:text-muted">
            <li>Nothing to prepare. We’ll come with your answers and our questions.</li>
            <li>Have your current software handy in case we want to look at something together.</li>
            <li>Invite anyone who should weigh in on billing, documents or timing.</li>
          </ul>
        </div>
        <ButtonLink to="/onboard/status" variant="primary" size="lg">View your migration status</ButtonLink>
        <p className="m-0 text-sm text-muted">Keep the link in your invitation email. It becomes your migration status page until your firm’s accounts are set up.</p>
      </div>
    </IntakeLayout>
  );
}
